import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=7afbce04"
import script from "./ResetPassword.vue?vue&type=script&lang=ts"
export * from "./ResetPassword.vue?vue&type=script&lang=ts"
import style0 from "./ResetPassword.vue?vue&type=style&index=0&id=7afbce04&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports